export default {
    purchase: 'ご購入により獲得',
    coupon: 'ディスカウントコード',
    login_capital_letters: 'ログイン',
    login_capital_letters1: 'ログイン',
    received: '獲得',
    subscribe_capital_letters: '登録',
    birthday_placeholder: 'MM / DD / YY',
    shop_capital_letters: '買い物',
    shop: '公式サイトで買い物',
    ecoflow_benefits: 'エコポイント会員になるメリット',
    complete_profile: 'プロフィールを完成',
    referral: '知り合いを招待する',
    referral_desc: '招待後に会員登録した友達の数に応じてエコポイントを獲得できます。',
    referral_btn: '招待メールを送る',
    warranty: '保証',
    points_activity_a: '私の実績',
    points_tab_name: 'ポイント実績',
    rewards_tab_name: '特典実績',
    coupon_used_desc: 'チェックアウト時にこのコードを入力して、{amont}分のギフトカードを適用します。',
    email_address: 'メールアドレス',
    give_away: '贈る',
    subscribe: '登録',
    welcome_title: 'こんにちは、{username}さん',
    welcome_sub_title: 'エコポイント特典プログラムにようこそ。',
    profile: 'プロフィール作成',
    status: 'ステータス',
    refund: '返金',
    points_balance: 'ポイント残高',
    points_progress_tips: '{plus}になるために必要なエコポイント {points} ポイント',
    available: '使用可能',
    sign_up_text: '参加時に500ポイント',
    redeemed_succ: '交換が成功しました！',
    current_tier: '現在のレベル',
    subscribe_now: '今すぐ登録',
    date: '日付',
    used: '使用済み',
    edeemed_rewards_note: '交換した特典はここに表示されます。',
    warranty_capital_letters: '保証',
    days_rules2: '*交換後の有効期間は{data}です。',
    redeem_now: '今すぐ交換',
    product_rules: '*{product}のみ対象です。',
    membership_includes: 'メンバーシップに含まれるもの',
    benefits_link_btn: 'ログイン',
    browse_ecocredits_rewards: 'エコポイント特典を閲覧',
    discount: 'ディスカウント',
    view_more: '詳細',
    profile_desc1: 'プロフィールを完成させると1,000ポイント獲得',
    profile_desc2: '詳細を追加することで最大1000ポイントを獲得できます。',
    points_capital_letters: 'ポイント',
    history_note:
        'あなたのポイントアクティビティーはここに表示されます。まだ受け取ったポイントが表示されていない場合もありますが、受け取り後24時間以内に更新されます。',
    lucky_flop_start: '今すぐ参加する',
    lucky_flop_congrat: 'おめでとうございます',
    lucky_flop_get: '請求する',
    lucky_flop_open: 'めくる',
    rules: '条件',
    completed_text: 'この特典はすでに達成しています。',
    completed_text2: 'この特典はすでに獲得しています。',
    redeemed: '使用済み',
    birthday: 'お誕生日の登録',
    summary_text: 'エコポイントの概要',
    deducted: '利用',
    site_rules: '*EcoFlow Japan公式サイトのストアでのみ適用します。',
    subscribe_hover: '参加時に500ポイントを獲得できます。',
    subscribe_text: 'EcoFlowのニュースレターに登録します。',
    store: '今すぐ購入',
    membership: '会員',
    join_now: '今すぐ参加',
    gift_card: 'ギフトカード',
    rewards_redeemed: '獲得した特典',
    redeedmed_tab_name: '交換済',
    issued_tab_name: '発行済',
    expired: '期限切れ',
    login: 'ログイン',
    earn_points_title: 'ポイントの貯め方',
    have_points: '<code>{points}ポイント</code>があります',
    view_all: 'すべて表示',
    add_your_birthday: '生年月日を追加',
    earn_point_rule_shop: '¥150につき1ポイントを獲得できます。',
    off: 'OFF',
    earn_point_by_order: '毎回のご注文でポイント獲得',
    registered: '登録済み',
    birthday_desc2: '生年月日を追加したときに{points}ポイントを獲得できます。',
    sign_up_desc_h: 'アカウント登録して500ポイント獲得',
    birthday_desc1: '生年月日を追加するとポイント獲得',
    or_text: 'または、',
    profile_a: 'プロフィール',
    days_rules: '*交換後、有効期限は{days}日間です。',
    join_title: 'エコポイント特典プログラムに参加',
    pending: '保留中',
    coming_soon: '近日公開予定',
    shop_to_earn_points: '買い物をしてポイントを獲得',
    action: '内容',
    rewards_title: '特典',
    question_title: 'クイズに回答',
    type_title: '種類',
    discount_type: '割引',
    already_member: '会員登録済ですか？',
    already_member1: '会員登録済ですか？',
    points_activity: 'ポイントアクティビティ',
    use_this_code_note: '精算時にこのコードを使用して<PI1/>のギフトカードと交換できます。',
    warranty_desc2: '製品を保証登録いただくと1,000ポイント獲得できます。',
    warranty_desc1: '製品登録すると1,000ポイント獲得',
    redeem_ecocredits_title: 'エコポイントを特典と交換する',
    points: 'ポイント',

    network_error: 'ネットワークエラー',
    confirm_text: '本当に交換をしますか？一度交換した特典を取り消すことはできません。',
    manually_deducted: '手動で差し引き',
    redeeming_points: 'ポイントを交換する',
    earning_points: 'ポイントを獲得する',
    confirm_btn: '確認',
    faq_title: 'よくあるご質問',
    no_enough_points: 'ポイントが不足しているため、交換に失敗しました',
    no_history_note: 'ま⁠だ⁠ポ⁠イ⁠ン⁠ト⁠が⁠表⁠示⁠さ⁠れ⁠な⁠い⁠場⁠合⁠も⁠あ⁠り⁠ま⁠す⁠が、ア⁠ク⁠テ⁠ィ⁠ビ⁠テ⁠ィ⁠は24時⁠間⁠以⁠内⁠に⁠更⁠新⁠さ⁠れ⁠ま⁠す。',
    no_coupon_note: 'まだ交換済みの特典はありません。',
    minimum_price: '*最低購入金額 ({price})。',
    minimum_num: '*最低購入個数以上 ({num} 個) の購入時に使用可能です。',
    stay_too_long: 'ページに止まる時間が長くて切れました。ページを更新してから確認してください。',
    order_rule: '*割引コードは、1回の注文につき1つしか利用することができません。',
    purchas_rule: '*クーポンの値引き額が商品金額を上回っていた場合、差額分は返金されません。',
    profile_birthday: 'プロファイルーお誕生日',
    profile_address: 'プロファイルー住所',
    profile_username: 'プロファイルーユーザー名',
    profile_picture: 'プロファイルー写真',
    profile_contact: 'プロファイルー連絡先情報',
    membership_faq_title: '会員資格',
    learn_more: '詳細はこちら',
    profile_detail: 'プロフィール写真 (200)、ユーザー名 (100)、連絡先情報 (300)、住所 (200)、生年月日 (200) を入力していただくと、1000ポイントを獲得できます。',
    exceeded_counts: '利用限度額を超えているため、交換できません。',
    grab_title: '特典のエコポイントを受け取る',
    grab_sub_title: 'エコポイント会員の期間限定特典があります。ここをクリックして今すぐ受け取りましょう！',
    grab_btn_text: '特典を受け取る',
    grab_success_title: 'おめでとうございます',
    grab_success_text1: '特典を受け取りました！\nチェックアウト時にこのディスカウントコードを入力することで、対象商品の価格が割引されます。',
    grab_success_text2: 'あなたが獲得した特典は<code>「交換済みの特典」</code>で確認できます。',
    'no-grab-content-note': '今後も続々更新予定ですので、ぜひお楽しみに！',
    copy_desc_2: 'コードをコピーしました.',
    city_validatino_error: '市区町村無効です',
    product_text: 'アイテム',
    shipping_address_text: 'お届け先',
    saved_address_text: '登録したお届け先',
    use_new_address: '新しい住所を使用',
    spend_now: 'ポイントを使用',
    stock_left: '残り{stock}個/台',
    no_stock_tip: '在庫切れ',
    order_text: '注文',
    campaign_time_limit_text: '交換有効期間：{startTime} - {endTime}.',
    lucky_turntable_title: 'ラッキールーレットに挑戦',
    join_lucky_with_points: 'エコポイント{points}ptにつきラッキールーレットに1回挑戦できます',
    join_lucky_with_points2: '1回 {points}エコポイントで挑戦できます。',
    join_lucky_desc: 'ルーレットを回してお得なクーポンをゲット！',
    remaining_number: '残り<code></code>回のチャンスがあります',
    remaining_number2: '残りのめくれる回数：<code></code>',
    learn_lucky_rule: '詳しくはこちら',
    prize_coupon_title: 'おめでとうございます',
    prize_coupon_sub_title: '賞品の請求が完了しました！チェックアウト時にコードを使用して保存します。',
    prize_coupon_action: '<code>マイリワード</code>で賞品を確認します。',
    prize_coupon_button: '今すぐ購入',
    prize_points_title: 'おめでとうございます',
    prize_points_desc: '<code>マイアクティビティ</code>で、追加したエコポイントを確認します。',
    limit_times_in_day: '<day></day>日に<count></count>回参加できます',
    limit_times_in_day2: 'カードは <day></day> 日間で <count></count> 回めくれます。',
    limit_times_in_active: 'キャンペーン期間内に<count></count>回参加できます',
    limit_times_in_active2: 'イベント中は、カードを最大 <count></count> 回めくれます。',
    without_limit_times: '有効期限なしでお好きな時に<count></count>回参加できます',
    without_limit_times2: 'カードはいつでも <count></count> 回めくれます。',
    active_is_unstart: 'このイベントはまもなく始まります。',
    active_is_ended: '本キャンペーンは終了しました。',
    over_max_count: '挑戦回数の上限に達しました。',
    event_action_text: 'ゲームに参加',
    warranty_minus_action_text: '保証記録が削除されました',
    question_correctly: '質問に正確に答えてください',
    clock_in: 'チェックイン',
    referral_correctly: '紹介プログラム',
    confirm_btn_text: 'ウィンドウを閉じる',
    notice_title: '※注意事項',
    points_cash: 'ポイント利用',
    Pending1: '保留中',
    rollback: '返却済み',
    level_change_log: 'レベル変動履歴',
    deadline: 'まで有効',
    history_refresh_member: '現在のレベル：会員',
    history_refresh_plus_member: '現在のレベル：PLUS会員',
    register: '会員登録',
    upgrade: 'PLUS会員にアップグレード',
    demotion: '会員にダウングレード',
    relegation: 'PLUS会員資格を保留',
    ecocredits_notice1:
        '2024 年 10 月 17 日にエコポイントのルールを更新しました。エコポイントを使用する前に、更新後の［<line1>エコポイントのルール</line1>］をよくお読みください。',
    wattayear_2024: 'シェア#WattAYear',
    copy_success1: 'コードをコピーしました。ストアにアクセスして使用してください。',
};
